import { ActionType, AppActionTypes } from '../types';

export function getServerStateAction(): AppActionTypes {
  return {
    type: ActionType.SERVER_STATE,
    payload: {
      request: {
        url: '/',
      },
    },
  };
}

export function resetServerRequestAction(actionType: ActionType): AppActionTypes {
  return {
    type: ActionType.RESET_SERVER_REQUEST,
    payload: actionType,
  };
}

export * from './user';
export * from './project';
export * from './workstation';
export * from './building';
export * from './ptw';
export * from './ehs';
